import request from '@/lib/request';

// ============ 认证模块 API ============

/**
 * 用户登录
 * POST /auth/login
 * 无需认证
 * identifyCode 为登录邮箱验证码，后端在认证前强制校验
 */
export const login = (data: { username: string; password: string; }) => {
  return request.post('/auth/login', data);
};

/**
 * 发送登录邮箱验证码
 * POST /identify/sendEmailCode
 * 无需认证
 */
export const sendEmailCode = (data: { email: string }) => {
  return request.post('/identify/sendEmailCode', data);
};

/**
 * 用户登出
 * POST /auth/logout
 * Bearer Token
 */
export const logout = () => {
  return request.post('/auth/logout');
};

/**
 * 获取当前用户信息
 * GET /auth/me
 * Bearer Token
 */
export const getCurrentUser = () => {
  return request.get('/auth/me');
};

/**
 * 用户注册
 * POST /auth/register
 * 无需认证
 */
export const register = (data: {
  loginName: string;
  password: string;
  name: string;
  phone?: string;
}) => {
  return request.post('/auth/register', data);
};

/**
 * 刷新Token
 * POST /auth/refresh
 * 无需认证
 */
export const refreshToken = (data: { refreshToken: string }) => {
  return request.post('/auth/refresh', data);
};

/** 忘记密码 - 发送验证码 */
export const sendForgotPasswordCode = (data: { loginName: string }) =>
  request.post('/forgot-password/send-code', data);

/** 忘记密码 - 校验验证码，获取 resetToken */
export const verifyForgotPasswordCode = (data: { loginName: string; code: string }) =>
  request.post('/forgot-password/verify-code', data);

/** 忘记密码 - 重置密码 */
export const resetPassword = (data: { resetToken: string; newPassword: string }) =>
  request.post('/forgot-password/reset', data);
